var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-scroll-area",
        { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
        [_c("tableusers", { attrs: { mode: "admin" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }